import { createAction } from 'redux-actions';
import {
  PROFILE_SET,
  PROFILE_SET_CHECKOUTS,
  PROFILE_SET_NAME,
  PROFILE_SET_PUBLISHER,
} from './constants/ActionTypes';
import {
  ICheckout,
  IProfileData,
  IProfileNameData,
  IProfilePublisherData,
} from './model';

const setProfile = createAction<IProfileData, IProfileData>(
  PROFILE_SET,
  (profileData: IProfileData) => ({
    uid: profileData.uid,
  })
);

const setPublisher = createAction<IProfilePublisherData, IProfilePublisherData>(
  PROFILE_SET_PUBLISHER,
  (profileData: IProfilePublisherData) => ({
    pubId: profileData.pubId,
  })
);

const setName = createAction<IProfileNameData, IProfileNameData>(
  PROFILE_SET_NAME,
  (data: IProfileNameData) => data
);

const setCheckouts = createAction<ICheckout[], ICheckout[]>(
  PROFILE_SET_CHECKOUTS,
  (data: ICheckout[]) => data
);

export { setCheckouts, setProfile, setName, setPublisher };



// WEBPACK FOOTER //
// ./src/profile/actions.ts